import React, { useEffect } from "react";

const SEO = ({
  title = "Online Indian Market (OIM)",
  description = "Online Indian Market (OIM) is India's leading B2B & B2C marketplace connecting manufacturers, wholesalers, retailers, sellers, and global buyers.",
  keywords = "Indian Manufacturers Suppliers Exporters Directory|Best B2B Marketplace in India|Top Indian Exporters and Suppliers Online|India Business Directory for Import Export|Verified Indian Companies Listings|Free Business Listing Site in India|Online Marketplace for Indian Manufacturers|Global B2B and B2C Trade Platform India|Top Industrial Suppliers & Exporters India|Find Indian Manufacturers and Wholesalers|India Export Import Business Directory|Trusted Indian Suppliers & Traders Online|Best SME Business Marketplace India|Indian Companies Database for Global Buyers|Business Directory Website for Manufacturers India|Online Supplier Directory for Industrial Products|Exporters and Importers Search India|Industrial Manufacturers Directory India|B2B Buying and Selling Platform India|Alternative to Yellow Pages India",
  author = "MR PRINCE GUPTA",
  url = "https://www.onlineindianmarket.com/",
  image = "https://www.onlineindianmarket.com/android-chrome-512x512.png",
  categories = [],
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Helper function to update or create meta tags by name
    const updateMetaTagByName = (name, content) => {
      let element = document.querySelector(`meta[name="${name}"]`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("name", name);
        document.head.appendChild(element);
      }
      element.setAttribute("content", content);
    };

    // Helper function to update or create meta tags by property
    const updateMetaTagByProperty = (property, content) => {
      let element = document.querySelector(`meta[property="${property}"]`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute("property", property);
        document.head.appendChild(element);
      }
      element.setAttribute("content", content);
    };

    // Update or create meta tags by name
    updateMetaTagByName("title", title);
    updateMetaTagByName("description", description);
    updateMetaTagByName("keywords", keywords);
    updateMetaTagByName("author", author);
    updateMetaTagByName("robots", "index, follow");
    updateMetaTagByName("language", "English");
    updateMetaTagByName("revisit-after", "1 days");

    // Open Graph tags
    updateMetaTagByProperty("og:type", "website");
    updateMetaTagByProperty("og:url", url);
    updateMetaTagByProperty("og:title", title);
    updateMetaTagByProperty("og:description", description);
    updateMetaTagByProperty("og:image", image);

    // Twitter tags
    updateMetaTagByName("twitter:card", "summary_large_image");
    updateMetaTagByName("twitter:title", title);
    updateMetaTagByName("twitter:description", description);
    updateMetaTagByName("twitter:image", image);
  }, [title, description, keywords, author, url, image]);

  // Handle JSON-LD schema
  useEffect(() => {
    if (categories.length === 0) return;

    const itemListSchema = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Business Categories",
      itemListOrder: "Ascending",
      numberOfItems: categories.length.toString(),
      itemListElement: categories.map((name, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: name,
      })),
    });

    // Remove existing schema script if any
    const existingScript = document.querySelector(
      'script[type="application/ld+json"][data-seo-schema]'
    );
    if (existingScript) {
      existingScript.remove();
    }

    // Add new schema script
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-seo-schema", "true");
    script.textContent = itemListSchema;
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.querySelector(
        'script[type="application/ld+json"][data-seo-schema]'
      );
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [categories]);

  return null; // This component doesn't render anything
};

export default SEO;
